const ArrowShareRight = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.1328 9.54122L11.3449 3.26239C10.9447 2.89221 10.2955 3.17605 10.2955 3.72121V6.6667C10.2955 6.89682 10.1055 7.08299 9.87539 7.08665C3.13767 7.19381 1.33716 9.93382 1.33716 16.875C2.56194 14.4255 3.18668 12.976 9.87459 12.9185C10.1047 12.9165 10.2955 13.1032 10.2955 13.3334V16.2789C10.2955 16.824 10.9447 17.1079 11.3449 16.7377L18.1328 10.4588C18.4003 10.2114 18.4003 9.78862 18.1328 9.54122Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowShareRight
